/** @format */

import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { ButtonLoading, InputV2, SelectV } from 'components';
import { makeStyles } from '@mui/styles';
import createToast from 'components/Toast/Toast';
import UploadMedia from './componenets/UploadMedia';
import { getHashe } from '../../services';
import { api } from 'utility';

export default function NewDoc({
  onAddFile = () => {},
  docTypes = [],
  getFileName = () => {
    return '';
  },
  selectedType,
}) {
  // --STATES--//
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');

  // --HOOKS--//
  const classes = useStyles();

  useEffect(() => {
    file && uploadFile();
  }, [file]);

  // --API--//
  const submitForm = async (e) => {
    // TODO: reform global errors style
    e.preventDefault();
    uploadFile();
  };

  const uploadFile = async () => {
    let message = null;
    if (!file) {
      message = 'ابتدا فایل سند را انتخاب کنید';
    }
    if (selectedType === 'OTHER' && !fileName) {
      message = 'ابتدا عنوان سند را وارد کنید';
    }
    if (!selectedType) {
      message = 'ابتدا نوع سند را وارد کنید';
    }

    const fileExtension = file.name.split('.').pop().toLowerCase();
    const acceptedExtensions = 'png, jpg, jpeg'
      .toLowerCase()
      .split(',')
      .map((ext) => ext.trim());

    if (!acceptedExtensions.includes(fileExtension)) {
      setLoading(false);
      setFileName('');
      setFile(null);
      return createToast(
        'خطا',
        ` فایل ارسال شده باید در فرمت های زیر باشد.
        png, jpg, jpeg`,
        'danger',
      );
    }
    if (file?.size > 6000000) {
      setLoading(false);
      setFileName('');
      setFile(null);
      // در تسک 4158 با خانم قلی نیا بررسی کردیم و بنا گرفتیم حجم فایل بیشتر از 6 مگ نباشد
      message = 'حجم فایل مورد نظر بیش از 6 مگابایت می باشد.';
    }
    if (message) {
      createToast('خطا', message, 'danger');
      setFile(null);
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    setLoading(true);

    const data = {
      size: 6000000,
      type: 'BUSINESS',
      'document-file-type': selectedType,
    };

    await getHashe(data)
      .then(async (res) => {
        if (res?.result?.uploadHash?.length) {
          await api
            .post(`${process.env?.REACT_APP_BASE_URL_UPLOAD_PODSAPCE + res?.result?.uploadHash}`, formData)
            .then(async (res) => {
              let data = res?.data?.result;
              createToast('موفق', 'سند با موفقیت بارگذاری شد', 'success');

              setLoading(false);
              setFileName('');
              setFile(null);
              onAddFile({
                file: data,
                name:
                  selectedType === 'OTHER'
                    ? fileName
                    : docTypes?.find((v) => v?.value === selectedType)?.label ?? '',
                type: selectedType,
              });
            })
            .catch((error) => {
              setLoading(false);
              setFile(null);
            });
        }
      })
      .catch((error) => {
        setLoading(false);
        setFile(null);
      });
  };
  return (
    <Grid
      container
      item
      xs={12}
      sm={6}
      lg={6}
      justifyContent="flex-start"
      style={{ alignSelf: 'flex-start' }}
      alignItems="flex-start"
      className={classes.root}
    >
      {/* TODO: Bellow form is inside it's parent (Business) form, it is not correct */}
      <Grid
        container
        item
        xs={12}
        justifyContent="flex-start"
        alignItems="flex-start"
        style={{ marginBottom: 'auto' }}
      >
        <form className={classes.form} onSubmit={submitForm} noValidate autoComplete="off">
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            item
            xs={12}
            direction="row"
            spacing={1}
          >
            {/* <Grid item xs={12}>
              <SelectV
                label="نوع سند"
                name="type"
                options={docTypes}
                fullWidth
                forceValue={selectedType}
                defaultValue=""
                onChangeFunc={(v, e) => setSelectedType(e?.target?.value)}
              />
            </Grid> */}
            {selectedType === 'OTHER' ? (
              <Grid item xs={12} className={classes.nameField}>
                <InputV2
                  name="fileName"
                  label="عنوان سند"
                  forceValue={fileName}
                  fullWidth
                  onChangeValue={(e) => setFileName(e?.target?.value)}
                  rules={['required']}
                />
              </Grid>
            ) : null}
          </Grid>
        </form>
      </Grid>
      <Grid container item xs={12} spacing={0} style={{ marginBottom: '16px' }}>
        <UploadMedia
          key={file} // TODO: Check on reset
          disabled={loading}
          file={file}
          setFile={(f) => setFile(f)}
          acceptFile={'png, pdf, zip, rar, jpg, jpeg'}
        />
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles((theme) => {
  return {
    form: {
      width: '100%',
    },
    submitButton: {
      marginTop: theme.spacing(1.5),
      height: 39,
    },
    nameField: { marginTop: '-24px' },
  };
});
